import { getOrCreateAnonymousId, getOrCreateSessionId } from './utils';

interface UseVisitorIdentityReturn {
	/** Empty string on SSR. */
	sessionId: string;
	anonymousId: string;
}

export function useVisitorIdentity(): UseVisitorIdentityReturn {
	return {
		sessionId: getOrCreateSessionId(),
		anonymousId: getOrCreateAnonymousId()
	};
}
